import React from 'react';
import './styles.css';
import logo from '../images/chacao-icon.png';

const Header = () => (
  <div className='Header'>
    <span className='Header_title'>INFOMAPA</span>
    <img className='Header__logo' src={logo} alt='' />
  </div>
);

export default Header;
